module.exports = __webpack_public_path__ + "static/media/gb-nir.737bda5a.svg";